import $ from 'jquery';

let quotes = $('blockquote');
let quoteIndex = -1;

if (quotes.length > 1) {
  let showNextQuote = function () {
    ++quoteIndex;

    quotes.eq(quoteIndex % quotes.length)
      .fadeIn(1500)
      .delay(5000)
      .fadeOut(1500, showNextQuote);
  };

  showNextQuote();

} else if (quotes.length === 1) {
  quotes.css('display', 'block');
}
